import config from '../constants/config.json'

function httpRequest(method, url, body = undefined) {
    const controller = new AbortController()
    const signal = controller.signal

    const request = fetch(config.api.url + url, {
        method: method,
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: "include",
        body: JSON.stringify(body),
        signal
    }).then(response => {
        return response.json().then(data => {
            return {
                data: data,
                status: response.status
            }
        }).catch(() => {
            throw 'uncorrectResponse' // eslint-disable-line
        })
    })

    return {
        controller: controller,
        ready: request
    }
}

const api = {
    authorization: {
        generateAuthPin: (credentials) => httpRequest('POST', '/api/v1/getpin', credentials),
        login: (creditionals) => httpRequest('POST', '/api/v1/auth', creditionals),
        loguot: () => httpRequest('HEAD', '/api/v1/logout')
    },
    user: {
        list: (offset, count, filRole, filFirstName, filLogin, filAuthType, filActive, sort) => {
            let params = {}
            if (offset !== undefined) params.offset = offset
            if (count !== undefined) params.count = count
            if (filRole !== undefined) params.filRole = filRole
            if (filFirstName !== undefined) params.filFirstName = filFirstName
            if (filLogin !== undefined) params.filLogin = filLogin
            if (filAuthType !== undefined) params.filAuthType = filAuthType
            if (filActive !== undefined) params.filActive = filActive
            if (sort !== undefined) params.sort = sort

            return httpRequest('GET', `/api/v1/user?${new URLSearchParams(params).toString()}`)
        },
        user: (id) => httpRequest('GET', `/api/v1/user/${id}`),
        edit: (user) => httpRequest('PATCH', `/api/v1/user/${user?.id}`, user),
        delete: (id) => httpRequest('DELETE', `/api/v1/user/${id}`),
        addUser: (user) => httpRequest('PUT', '/api/v1/user', user)
    },
    departure: {
        list: (offset, count, filDateOrderFrom, filDateOrderTo, filElevator, filCar, filDriver, filType, filStep, filWaybill, filCounterparty, sort) => {
            let params = {}
            if (offset !== undefined) params.offset = offset
            if (count !== undefined) params.count = count
            if (filDateOrderFrom !== undefined) params.filDateOrderFrom = filDateOrderFrom
            if (filDateOrderTo !== undefined) params.filDateOrderTo = filDateOrderTo
            if (filElevator !== undefined) params.filElevator = filElevator
            if (filCar !== undefined) params.filCar = filCar
            if (filDriver !== undefined) params.filDriver = filDriver
            if (filType !== undefined) params.filType = filType
            if (filStep !== undefined) params.filStep = filStep
            if (filWaybill !== undefined) params.filWaybill = filWaybill
            if (filCounterparty !== undefined) params.filCounterparty = filCounterparty
            if (sort !== undefined) params.sort = sort

            return httpRequest('GET', `/api/v1/departure?${new URLSearchParams(params).toString()}`)
        },
        departure: (id) => httpRequest('GET', `/api/v1/departure/${id}`)
    },
    residue: {
        list: (customer, offset, count, filElevator, filCropType, filCounterparty, sort) => {
            let params = {}
            if (customer !== undefined) params.customer = customer
            if (offset !== undefined) params.offset = offset
            if (count !== undefined) params.count = count
            if (filElevator !== undefined) params.filElevator = filElevator
            if (filCropType !== undefined) params.filCropType = filCropType
            if (filCounterparty !== undefined) params.filCounterparty = filCounterparty
            if (sort !== undefined) params.sort = sort

            return httpRequest('GET', `/api/v1/residue?${new URLSearchParams(params).toString()}`)
        }
    },
    elevators: {
        list: () => httpRequest('GET', `/api/v1/elevator`)
    },
    nomenclatures: {
        list: () => httpRequest('GET', `/api/v1/nomenclature`)
    },
    driver: {
        list: (offset, count, filFirstName, filLastName, filActive, driversLicense) => {
            let params = {}
            if (offset !== undefined) params.offset = offset
            if (count !== undefined) params.count = count
            if (filFirstName) params.filFirstName = filFirstName;
            if (filLastName) params.filLastName = filLastName;
            if (driversLicense) params.driversLicense = driversLicense;
            if (filActive && filActive.length > 0) params.filActive = filActive;
            return httpRequest('GET', `/api/v1/driver?${new URLSearchParams(params).toString()}`)
        },
        driver: (id) => httpRequest('GET', `/api/v1/driver/${id}`),
        edit: (driver) => httpRequest('PATCH', `/api/v1/driver/${driver.id}`, driver),
        add: (driver) => httpRequest('PUT', `/api/v1/driver`, driver)
    },
    cars: {
        list: () => httpRequest('GET', `/api/v1/car`),
        edit: (id, car) => httpRequest('PATCH', `/api/v1/car/${id}`, car)
    },
    queue: {
        list: (offset, count) => httpRequest('GET', `/api/v1/queue?offset=${offset}&count=${count}`),
        delete: (id) => httpRequest('DELETE', `/api/v1/queue/${id}`)
    },
    request: {
        send: (values) => httpRequest('POST', `/api/v1/request`, values)
    },
    crash: {
        list: () => httpRequest('GET', '/api/v1/crash'),
        confirm: (id, options) => httpRequest('POST', `/api/v1/crash/${id}`, options)
    },
    cultures: {
        list: () => httpRequest('GET', `/api/v1/culture`),
    },
    applications: {
        list: (offset, count, sort, filCultures, filWarehouses, filCounterparties, filDepartureType, filScheduledDate, filCreatedDate, filConfirmedDate, filWeightFrom, filWeightTo, filStatus, filMonth, filDay) => {
            const params = {}
            if (offset) params.offset = offset;
            if (count) params.count = count;
            if (sort) params.sort = sort;
            if (filCounterparties) params.filCounterparties = filCounterparties;
            if (filCultures) params.filCultures = filCultures;
            if (filWarehouses) params.filWarehouses = filWarehouses;
            if (filDepartureType) params.filDepartureType = filDepartureType;
            if (filScheduledDate) params.filScheduledDate = filScheduledDate;
            if (filCreatedDate) params.filCreatedDate = filCreatedDate;
            if (filConfirmedDate) params.filConfirmedDate = filConfirmedDate;
            if (filWeightFrom) params.filWeightFrom = filWeightFrom;
            if (filWeightTo) params.filWeightTo = filWeightTo;
            if (filStatus) params.filStatus = filStatus;
            if (filMonth) params.filMonth = filMonth;
            if (filDay) params.filDay = filDay;
            return httpRequest('GET', `/api/v1/application?${new URLSearchParams(params).toString()}`)
        },
        addApplication: (data) => httpRequest('POST', '/api/v1/application', data),
        editApplication: ({ id, statusId, rejectionReason = null }) => httpRequest('PATCH', `/api/v1/application/${id}`, { statusId, rejectionReason }),
        updateApplicationsList: ({ applicationsIdList, statusId, rejectionReason = null }) => httpRequest('PATCH', '/api/v1/updateApplicationsList', { applicationsIdList, statusId, rejectionReason }),
    },
    rejectionReasons: {
        list: () => httpRequest('GET', '/api/v1/rejectionReason')
    },
    applicationsStatuses: {
        list: () => httpRequest('GET', '/api/v1/applicationsStatus')
    },
    blockedDays: {
        list: () => httpRequest('GET', '/api/v1/calendarDays'),
        addUpdateDay: (data) => httpRequest('POST', '/api/v1/calendarDays', data)
    },
    suggestedEdits: {
        add: ({ id, nomenclature, elevator, weight, scheduledDate }) => {
            const data = {}
            if (id) data.id = id;
            if (nomenclature) data.nomenclature = nomenclature;
            if (elevator) data.elevator = elevator;
            if (weight) data.weight = weight;
            if (scheduledDate) data.scheduledDate = scheduledDate;
            return httpRequest('POST', '/api/v1/suggestedEdits', data)
        }
    },
    completedGrainOperationsData: {
        list: (targetDate) => httpRequest('GET', `/api/v1/completedGrainOperationsData?targetDate=${targetDate}&onlyForCurrentDay=yes`),
        getCalendarDaysData: (date) => httpRequest('GET', `/api/v1/completedGrainOperationsData?targetDate=${date}`)
    },
    crashHistory:{
        list: ({offset, count, confirmed, crashed, filCarNumber, filDateFrom, filDateTo, filCurrentPoint, filReason, filStatus, departureId}) =>{
            const params = {}
            if (offset) params.offset = offset;
            if (count) params.count = count;
            if (confirmed) params.confirmed = confirmed;
            if (crashed) params.crashed = crashed;
            if (filCarNumber) params.filCarNumber = filCarNumber;
            if (filDateFrom) params.filDateFrom = filDateFrom;
            if (filDateTo) params.filDateTo = filDateTo;
            if (filCurrentPoint) params.filCurrentPoint = filCurrentPoint;
            if (filReason) params.filReason = filReason;
            if (filStatus) params.filStatus = filStatus;
            if (departureId) params.departureId = departureId;
            return httpRequest("GET", `/api/v1/crashHistory?${new URLSearchParams(params).toString()}`)
        }
    },
    conrolPoints:{
        list: ({offset, count, filCarNumber, filDateFrom, filDateTo}) => {
            const params = {}
            if (offset) params.offset = offset;
            if (count) params.count = count;
            if (filCarNumber) params.filCarNumber = filCarNumber;
            if (filDateFrom) params.filDateFrom = filDateFrom;
            if (filDateTo) params.filDateTo = filDateTo;
            return httpRequest("GET", `/api/v1/departureRouteData?${new URLSearchParams(params).toString()}`)
        }
    }
}

export default api
